import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core'
import { Rating } from '@mui/material'
import React from 'react'

const WorkshiftDetails_Employer = ({
  classes,
  t,
  task_description,
  entrepreneur,
  email,
  location,
  workshift_date,
  working_hours,
  workshift_lastdate,
  status,
  additional_info,
  status_entrepreneur,
  status_employer,
  deleteWorkshift,
  workshift_id,
  workshift_itemid,
  getWorkshiftbyId,
  setSelectedWorkshift,
  actualworkshift_starttime,
  actualworkshift_endtime,
  workshift_additional_comments,
  actual_hours,
  time_spent,
  emailSelectionList,
  entrepreneurs_rating,
  confirmBillableHour,
  isConfirmActualHours,
  setIsConfirmActualHours,
  isRejectActualHours,
  setIsRejectActualHours,
  showWorkshiftFormDialog,
  workshift_remarks = null
}) => {
  const [rateValue, setRateValue] = React.useState(null)
  const [message, setMessage] = React.useState('')
  const isShowRating = emailSelectionList.some(
    (entry) => entry.offered_entrepreneur_email === email && entry.AcceptRatings
  )
  const confirmBillableHourBody = {
    workshift_id: workshift_id,
    workshift_itemid: workshift_itemid,
    rateentrepreneur: rateValue,
    actualbilledhours: actual_hours,
    timespent: time_spent,
    workShiftRemarks: message
  }

  confirmBillableHourBody.workshiftstatus = isRejectActualHours ? 6 : 3

  return (
    <div>
      <div
        style={{
          border: '1px solid #D3D3D3',
          borderRadius: '5px'
        }}
      >
        <div style={{ padding: '25px' }}>
          <div>
            <p className={classes.previewLabel}>
              {t('employer.workshifts.col1')}
            </p>
            <p>{task_description}</p>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.col2')}
              </p>
              <p>{entrepreneur}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.col15')}
              </p>
              <p>{email}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.col5')}
              </p>
              <p>{location}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.col3')}
              </p>
              <p>{workshift_date}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <p className={classes.previewLabel}>
                {status_entrepreneur === 0 ||
                status_entrepreneur === 1 ||
                status_entrepreneur === 4
                  ? t('employer.workshifts.col4')
                  : t('employer.workshifts.col11')}
              </p>
              <p>{working_hours}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              {status_entrepreneur === 0 ||
              status_entrepreneur === 1 ||
              status_entrepreneur === 4 ? (
                <div>
                  <p className={classes.previewLabel}>
                    {t('employer.workshifts.col6')}
                  </p>
                  <p>{workshift_lastdate}</p>
                </div>
              ) : (
                isShowRating &&
                status_entrepreneur === 3 && (
                  <div>
                    <p className={classes.previewLabel}>
                      {t('employer.workshifts.col14')}
                    </p>
                    <Rating
                      name="simple-controlled"
                      size="large"
                      value={entrepreneurs_rating}
                      disabled={true}
                    />
                  </div>
                )
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.col8')}
              </p>
              <p>{status}</p>
            </div>
          </div>
          <div>
            <p className={classes.previewLabel}>
              {t('employer.workshifts.col7')}
            </p>
            <div
              dangerouslySetInnerHTML={{ __html: additional_info }}
              style={{ overflowWrap: 'break-word' }}
            />
          </div>
        </div>
      </div>
      {(status_entrepreneur === 2 ||
        status_entrepreneur === 3 ||
        status_entrepreneur === 6) && (
        <div
          style={{
            border: '1px solid #D3D3D3',
            borderRadius: '5px',
            marginTop: '15px',
            padding: '25px'
          }}
        >
          <div>
            <p>
              <b>
                {(status_entrepreneur === 2 || status_entrepreneur === 6) && (
                  <p>{t('employer.ws_status.2')}</p>
                )}
                {status_entrepreneur === 3 && (
                  <p>{t('employer.ws_status.3')}</p>
                )}
              </b>{' '}
            </p>
          </div>
          <div className="row">
            <div className="col-xs-6 col-sm-6 col-md-3 col-lg-2">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.col17')}
              </p>
              <p>{actualworkshift_starttime}</p>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-3 col-lg-2">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.col18')}
              </p>
              <p>{actualworkshift_endtime}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-2">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.col12')}
              </p>
              <p>{time_spent}</p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <p className={classes.previewLabel}>
                {t('employer.workshifts.note')}
              </p>
              <p style={{ overflowWrap: 'break-word' }}>
                {workshift_additional_comments}
              </p>
            </div>
          </div>
          {workshift_remarks && <hr />}
          {workshift_remarks?.map((item, index) => (
            <div key={index}>
              <p style={{ overflowWrap: 'break-word' }}>
                {item.workshift_remarks}
              </p>
            </div>
          ))}
        </div>
      )}
      {status_entrepreneur === 0 && status_employer === 0 && (
        <div className="pull-right" style={{ padding: '8px 0px 8px' }}>
          <Button
            variant="outlined"
            onClick={() => {
              deleteWorkshift(workshift_id, workshift_itemid)
            }}
          >
            {t('employer.workshifts.btn5')}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              getWorkshiftbyId(workshift_id)
              showWorkshiftFormDialog() // The work shift modal form is placed at workshifts.component (parent component)
              // setSelectedWorkshift(null)
            }}
          >
            {t('employer.workshifts.btn7')}
          </Button>
        </div>
      )}
      {((status_entrepreneur === 2 && status_employer === 0) ||
        (status_entrepreneur === 6 && status_employer === 6) ||
        (status_entrepreneur === 2 && status_employer === 6)) && (
        <div className="pull-right" style={{ padding: '8px 0px 8px' }}>
          <Button
            variant="contained"
            style={{ marginRight: '15px' }}
            onClick={() => {
              setIsConfirmActualHours(true)
            }}
          >
            {t('employer.workshifts.btn4')}
          </Button>
          <Button
            variant="outlined"
            style={{ marginRight: '0px' }}
            onClick={() => {
              setIsRejectActualHours(true)
            }}
          >
            {t('employer.workshifts.btn4a')}
          </Button>
        </div>
      )}
      <Dialog
        open={isConfirmActualHours}
        onClose={() => {
          setIsConfirmActualHours(false)
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        BackdropProps={{
          classes: {
            root: classes.dialog
          }
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          <div style={{ textAlign: 'center' }}>
            <span style={{ fontSize: '18px' }}>
              {isShowRating
                ? t('employer.workshifts.dialogContent1')
                : t('employer.workshifts.dialogTitle3')}
            </span>
          </div>
        </DialogTitle>
        {isShowRating && (
          <DialogContent>
            <div style={{ textAlign: 'center' }}>
              <p>{t('employer.workshifts.dialogContentText1')}</p>
              <Rating
                name="simple-controlled"
                size="large"
                value={rateValue}
                onChange={(event, newValue) => {
                  setRateValue(newValue)
                }}
                sx={{}}
              />
              <p>{t('employer.workshifts.dialogContentText2')}</p>
              <textarea
                style={{ width: '80%', height: '100px' }}
                onChange={(event) => {
                  setMessage(event.target.value)
                }}
              ></textarea>
            </div>
          </DialogContent>
        )}
        <DialogActions>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Button
              variant="contained"
              className={classes.dialogButton}
              onClick={() => {
                confirmBillableHour(confirmBillableHourBody)
                setIsConfirmActualHours(false)
                setSelectedWorkshift(null)
              }}
            >
              {t('employer.workshifts.btn8')}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isRejectActualHours}
        onClose={() => {
          setIsRejectActualHours(false)
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        BackdropProps={{
          classes: {
            root: classes.dialog
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <span style={{ fontSize: '18px' }}>
            {t('employer.workshifts.dialogTitle4')}
          </span>
        </DialogTitle>
        <DialogContent>
          <div style={{ textAlign: 'center' }}>
            <p>{t('employer.workshifts.dialogContentText3')}</p>
            <textarea
              style={{ width: '80%', height: '100px' }}
              onChange={(event) => {
                setMessage(event.target.value)
              }}
            ></textarea>
          </div>
        </DialogContent>
        <DialogActions>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Button
              variant="contained"
              className={classes.dialogButton}
              onClick={() => {
                confirmBillableHour(confirmBillableHourBody)
                setIsRejectActualHours(false)
                setSelectedWorkshift(null)
              }}
            >
              {t('employer.workshifts.btn8')}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default WorkshiftDetails_Employer
